<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
        <v-icon color="white" small v-on="on">fa-edit</v-icon>
    </template>
    <v-card>
      <v-tabs fixed-tabs>
        <v-tab left ripple>{{$t("edit")}} {{$t("user")}}</v-tab>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field
                  outlined
                  dense
                  required
                  :rules="nameRules()"
                  v-model="editedUser.Firstname"
                  v-bind:label="$t('firstname')"
                ></v-text-field>
                <v-text-field
                  outlined
                  dense
                  required
                  :rules="nameRules()"
                  v-model="editedUser.Name"
                  v-bind:label="$t('name')"
                ></v-text-field>
                 <v-text-field
                  outlined
                  dense
                  required
                  persistent-hint
                  :hint="$t('contactEmailHint')"
                  :rules="emailRules()"
                  browser-autocomplete="new-password"
                  autocomplete="new-password"
                  v-model="editedUser.Email"
                  v-bind:label="$t('contactEmail')"
                ></v-text-field>
                <v-text-field
                  outlined
                  dense
                  required
                  :rules="emailRules()"
                  browser-autocomplete="new-password"
                  autocomplete="new-password"
                  v-model="editedUser.Login"
                  v-bind:label="$t('loginEmail')"
                persistent-hint
                :hint="$t('loginEmailHint')"
                ></v-text-field>
                <v-text-field
                  outlined
                  dense
                  browser-autocomplete="new-password"
                  autocomplete="new-password"
                  :type="show ? 'text' : 'password'"
                  v-model="inputP"
                  v-bind:label="$t('changePassword')"
                  :append-icon="show ? 'visibility' : 'visibility_off'"
                  @click:append="show = !show"
                  required
                  @input="encrypt"
                ></v-text-field>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close">{{$t('close')}}</v-btn>
        <v-btn color="primary" text @click="save">{{$t('save')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import uuid from "uuid";
import sha256 from "sha256";
import jwtdecode from "jwt-decode";

export default {
  props: ["user"],
  data: () => ({
    // editedUser: {},
    show: false,
    dialog: false,
    inputP: "",
    key: "",
    valid: true
  }),
  computed:{
      editedUser(){
          return this.user
      }
  },
  methods: {
    close() {
      this.dialog = false;
    },
    nameRules() {
      return [v => !!v || `${this.$t("name")} ${this.$t("required")}`];
    },
    emailRules() {
      return [
        v => !!v || `${this.$t("email")} ${this.$t("required")}`,
        v => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(v) || `${this.$t("email")} ${this.$t("invalid")}`;
        }
      ];
    },
    passwordRules() {
      return [
        v => !!v || `${this.$t("password")} ${this.$t("required")}`,
        v => v.length >= 8 || `${this.$t("min8")}`
      ];
    },
    encrypt() {
      this.editedUser.key = sha256(this.inputP);
    },

    save() {
      if (this.$refs.form.validate()) {
        this.editedUser.id = this.editedUser.Id
        this.$http.updateCustomerContact(this.editedUser)
        .then(res => {
          this.$emit("update-user", this.editedUser);
          this.$noty.success(this.$t('success'))
          this.close();
        }).catch(error => {
          console.log(error)
          this.$noty.error(error)
        })
        
        
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/pages/Users/EditUser.vue